<div class="price-list-printable">
  <table>
    <thead>
      <tr>
        <td>
          <div class="price-list-printable__header-space">&nbsp;</div>
        </td>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td>
          <lx-price-lists-portal-table-of-content
            [tableOfContents$]="tableOfContents$"
            [area]="priceListArea$ | async"
          ></lx-price-lists-portal-table-of-content>
          <lx-price-lists-portal-why-choose-positively-languages></lx-price-lists-portal-why-choose-positively-languages>
          <div class="price-list-printable__section" *ngIf="kaplanPriceLists$ | async as priceLists">
            <lx-price-lists-portal-price-lists-data [priceLists]="priceLists"></lx-price-lists-portal-price-lists-data>
          </div>

          <div class="price-list-printable__section price-list-alpadia" *ngIf="alpadiaPriceLists$ | async as priceLists">
            <lx-price-lists-portal-price-lists-data [priceLists]="priceLists"></lx-price-lists-portal-price-lists-data>
          </div>

          <div class="price-list-printable__section" *ngIf="(ayaSchoolTables$ | async)?.length">
            <lx-price-lists-portal-aya-data [ayaSchoolTables$]="ayaSchoolTables$"></lx-price-lists-portal-aya-data>
          </div>

          <div class="price-list-printable__section" *ngIf="juniorCampsPriceLists$ | async as juniorCamps">
            <lx-price-lists-portal-junior-camps-price-list-data [camps]="juniorCamps.camps"></lx-price-lists-portal-junior-camps-price-list-data>
          </div>

          <div class="price-list-printable__section" *ngIf="youngAdultsPriceLists$ | async as youngAdultsSchools">
            <lx-price-lists-portal-young-adults-price-list-data [schools]="youngAdultsSchools.schools"></lx-price-lists-portal-young-adults-price-list-data>
          </div>

          <div class="price-list-printable__section">
            <lx-price-lists-portal-online-courses></lx-price-lists-portal-online-courses>
          </div>

          <div class="price-list-printable__section">
            <lx-price-lists-portal-public-holidays class="price-list-printable__section"></lx-price-lists-portal-public-holidays>
          </div>

          <div class="price-list-printable__section">
            <lx-price-lists-portal-terms-and-conditions
              class="price-list-printable__section"
              title="Kaplan Terms & Conditions"
              [company]="CompanyEnum.KIL"
            ></lx-price-lists-portal-terms-and-conditions>
          </div>

          <div class="price-list-printable__section">
            <lx-price-lists-portal-terms-and-conditions
              title="Alpadia Terms & Conditions"
              class="price-list-printable__section"
              [company]="CompanyEnum.ALP"
            ></lx-price-lists-portal-terms-and-conditions>
          </div>
        </td>
      </tr>
    </tbody>
    <tfoot>
      <tr>
        <td>
          <div class="price-list-printable__footer-space">&nbsp;</div>
        </td>
      </tr>
    </tfoot>
  </table>
  <div class="price-list-printable__header">
    <img class="price-list-printable__header__logo" [src]="companyLogoPath" alt="company logo" #headerLogo />
  </div>
  <div class="price-list-printable__footer">Kaplan Pricelist / {{ priceListArea$ | async }}</div>
</div>
